import "react-datepicker/dist/react-datepicker.css";
import { subDays, subYears } from "date-fns";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Dropdown, Form } from "semantic-ui-react";
import { getTimeRollUps } from "../../../../libs/common_utils";
import { AdvertiserField } from "../../common/components/AdvertiserField";
import { CampaignsField } from "../../common/components/CampaignsField";
import { DateRangePickerField } from "../../common/components/DateRangePickerField";
import { DateWindowField } from "../../common/components/DateWindowField";
import { useReportForm } from "../../hooks/useReportForm";

const DATE_NOW = new Date();
const MINIMAL_START_DATE = subYears(DATE_NOW, 1);
const MAXIMAL_END_DATE = subDays(DATE_NOW, 1);

const ReportParamsForm = ({ values, updateValues, onSubmit, type }) => {
  const intl = useIntl();
  const timeRollup = getTimeRollUps(intl);
  const {
    advertisers,
    campaigns,
    advertisersLoading,
    campaignsLoading,
    campaignSearchQuery,
    handleStartDateChange,
    handleEndDateChange,
    resetSelectedCampaigns,
    setCampaignSearchQuery,
    trimmingSearch,
    performSearchAdvertisersDebounced,
    performSearchCampaignsDebounced,
    setAdvertisers,
    initialAdvertisers,
    resetCampaigns,
  } = useReportForm({ values, updateValues, type });

  return (
    <>
      <Form
        autoComplete="off"
        onSubmit={onSubmit}
      >
        <Form.Group>
          <DateWindowField
            values={values}
            updateValues={updateValues}
            dateWindowType="reporting_period"
          />

          {values.reporting_period === "custom" && (
            <DateRangePickerField
              values={values}
              onStartDateChange={handleStartDateChange}
              onEndDateChange={handleEndDateChange}
              minimalStartDate={MINIMAL_START_DATE}
              maximalEndDate={MAXIMAL_END_DATE}
            />
          )}

          <Form.Field className="filter-field">
            <label>
              {intl.formatMessage({
                id: "LABEL_AGGREGATION",
                defaultMessage: "Aggregation",
              })}
            </label>
            <Dropdown
              data-id="time_rollup"
              selection
              options={timeRollup}
              name="time_rollup"
              value={values.time_rollup}
              selectOnNavigation={false}
              onChange={(_e, data) => {
                updateValues({
                  // biome-ignore lint/style/useNamingConvention: <server prop>
                  time_rollup: data.value,
                });
              }}
            />
          </Form.Field>

          <AdvertiserField
            values={values}
            updateValues={updateValues}
            advertisers={advertisers}
            advertisersLoading={advertisersLoading}
            campaignsLoading={campaignsLoading}
            trimmingSearch={trimmingSearch}
            performSearchAdvertisersDebounced={performSearchAdvertisersDebounced}
            setAdvertisers={setAdvertisers}
            initialAdvertisers={initialAdvertisers}
          />

          <CampaignsField
            values={values}
            updateValues={updateValues}
            campaigns={campaigns}
            campaignsLoading={campaignsLoading}
            advertisersLoading={advertisersLoading}
            trimmingSearch={trimmingSearch}
            resetSelectedCampaigns={resetSelectedCampaigns}
            campaignSearchQuery={campaignSearchQuery}
            setCampaignSearchQuery={setCampaignSearchQuery}
            performSearchCampaignsDebounced={performSearchCampaignsDebounced}
            type={type}
            resetCampaigns={resetCampaigns}
          />
        </Form.Group>
      </Form>
    </>
  );
};
ReportParamsForm.propTypes = {
  values: PropTypes.object.isRequired,
  updateValues: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ReportParamsForm;
